import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const convertUtcToLocal = (dateTime, format = "YYYY-MM-DD HH:mm:ss") => {
    return dayjs.utc(dateTime).local().format(format);
};

export default convertUtcToLocal;
